import {Collection, Model} from 'backbone'

export default class Coll extends Collection {

    get url(){
        return APP_API_PATH+'/bus-reservation/'+this.email
    }

    lookup(email){
        this.email = email
        if( email )
            return this.fetchSync()
        this.reset()
    }

    get canReserve(){
        return this.length > 0 && !this.find(m=>m.get('bus_route'))
    }

    reserve(payment){
        let error = false
        let details = this.map(m=>{
            if( !m.get('_bus_route') )
                error = true
            return {
                id:m.id,
                bus_route:m.get('_bus_route')
            }
        })

        if( error ) throw Error('bus route missing')

        return this.fetchSync({data: {reserve:details, payment}})
    }
}

export class BusRoutes extends Collection {

    get url(){
        return APP_API_PATH+'/bus-reservation/routes'
    }
    get model(){
        return Route
    }
}

class Route extends Model {
    get label(){
        return this.get('direction')+' '+this.get('location')
    }
}